var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "contents" },
    [
      _c(
        "div",
        { staticClass: "flex mr-4", staticStyle: { flex: "0" } },
        [
          _vm.item.participants.length > 1
            ? _c(
                "v-badge",
                {
                  attrs: {
                    content: _vm.item.participants.length,
                    overlap: "",
                    bottom: "",
                    color: "dark",
                    "offset-y": "20",
                  },
                },
                [
                  _c(
                    "v-avatar",
                    {
                      class: {
                        "unread-avatar":
                          !_vm.item.last_read ||
                          _vm.item.last_read <
                            _vm.item.latest_message.created_at,
                      },
                    },
                    [
                      _c("v-img", {
                        attrs: {
                          src: _vm.item.participants[0].profile_photo_url,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _c(
                "v-avatar",
                {
                  class: {
                    "unread-avatar":
                      !_vm.item.last_read ||
                      _vm.item.last_read < _vm.item.latest_message.created_at,
                  },
                },
                [
                  _vm.item.participants[0].profile_photo_url
                    ? _c("v-img", {
                        attrs: {
                          src: _vm.item.participants[0].profile_photo_url,
                        },
                      })
                    : _c("v-icon", { attrs: { size: "48", color: "dark" } }, [
                        _vm._v("account_circle"),
                      ]),
                ],
                1
              ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-list-item-content",
        {
          class: {
            "font-weight-bold": _vm.item.unread,
          },
        },
        [
          _c(
            "v-list-item-title",
            { staticClass: "ws-wrap soli-grey items-center" },
            [
              _vm._v(
                _vm._s(
                  _vm.item.participants.length > 1
                    ? _vm.item.firstNameList
                    : _vm.item.fullNameList
                ) + "\n        "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "v-list-item-subtitle",
            { staticClass: "ws-wrap min-three-line" },
            [_vm._v(_vm._s(_vm.item.latest_message.content))]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex gap-2 items-center" },
            [
              _c(
                "small",
                {
                  staticClass: "accent--text",
                  class: {
                    "max-w-24 text-ellipsis whitespace-nowrap text-ellipsis overflow-hidden":
                      _vm.item.hasDraft,
                  },
                },
                [_vm._v(_vm._s(_vm.moment(_vm.item.updated_at).fromNow()))]
              ),
              _vm._v(" "),
              _vm.item.hasDraft
                ? _c(
                    "v-chip",
                    {
                      class: {
                        "gradient-ai white--text": _vm.item.auto_drafted_at,
                      },
                      attrs: { color: "accent", "x-small": "" },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.item.auto_drafted_at ? "Auto-drafted" : "Draft"
                        )
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }